// extracted by mini-css-extract-plugin
module.exports = {"hover":"TableBody_hover__1tKPK","strip":"TableBody_strip__18zPY"};